import React from "react";

const Hero = () => {
  return <section className="Custom_banner hero_overlay" aria-hidden="true" />;
};

export default Hero;
